module.exports = __webpack_public_path__ + "static/media/distribuidores.d1037bfd.jpg";